import styled from 'styled-components';
import Rhombus from '../assets/images/Rhombus.gif';

const StyledLoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const LoadingGif = styled.img`
  width: 100px; // GIF 크기 설정
  height: 100px;
  border-radius: 10px;
`;

const LoadingOverlay = () => {
  return (
    <StyledLoadingOverlay>
      <LoadingGif src={Rhombus} alt="Loading..." />
    </StyledLoadingOverlay>
  );
};

export default LoadingOverlay;
